/**
 * Orari suggeriti + «Inserisci un altro orario» (HH:MM, 24h, nessun arrotondamento).
 */
import React, { useEffect, useState } from "react";

export const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;

const formatTyping = (raw) => {
  const d = raw.replace(/[^0-9]/g, "").slice(0, 4);
  return d.length > 2 ? `${d.slice(0, 2)}:${d.slice(2)}` : d;
};

export default function ReservationsTimePicker({ value, quickTimes, onChange, isPast }) {
  const isCustom = !!value && !quickTimes.includes(value);
  const [open, setOpen] = useState(isCustom);
  const [draft, setDraft] = useState(isCustom ? value : "");

  useEffect(() => {
    if (quickTimes.includes(value)) { setDraft(""); }
  }, [value, quickTimes]);

  const onType = (raw) => {
    const v = formatTyping(raw);
    setDraft(v);
    if (TIME_RE.test(v)) { onChange(v); }
    else if (v) { onChange(""); }
  };
  const invalid = draft.length > 0 && !TIME_RE.test(draft);

  return (
    <div>
      <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-3 lg:grid-cols-5 gap-2">
        {quickTimes.map((t) => (
          <button key={t} type="button" onClick={() => { onChange(t); setOpen(false); }}
                  data-testid={`booking-time-${t}`}
                  className={`h-11 rounded-xl border text-base tabular-nums transition-colors ${
                    value === t ? "bg-ink-900 text-white border-ink-900"
                                : "bg-white border-sand-300 text-ink-900 hover:border-bronze-400"}`}>
            {t}
          </button>
        ))}
      </div>
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} data-testid="booking-time-toggle"
                className="mt-2 text-sm text-bronze-700 font-medium hover:underline">
          + Inserisci un altro orario
        </button>
      ) : (
        <div className="mt-2 flex items-center gap-2">
          <input type="text" inputMode="numeric" autoComplete="off" placeholder="HH:MM" maxLength={5}
                 value={draft} onChange={(e) => onType(e.target.value)}
                 aria-label="Altro orario (HH:MM)" data-testid="booking-time-custom"
                 className={`w-28 h-11 px-3 rounded-xl border text-lg tabular-nums text-center bg-white ${
                   isCustom && !invalid ? "border-ink-900 ring-1 ring-ink-900"
                     : invalid ? "border-rose-400" : "border-sand-300"}`} />
          <span className="text-xs text-ink-500">
            {invalid ? <span className="text-rose-700" data-testid="booking-time-invalid">
                {draft.length < 5 ? "Completa l'orario (HH:MM)" : "Orario non valido (00:00–23:59)"}</span>
              : "Formato 24 ore, es. 20:15"}
          </span>
        </div>
      )}
      {isPast && (
        <p className="mt-2 text-xs text-amber-800" data-testid="booking-time-past">
          Attenzione: l'orario di oggi è già trascorso.
        </p>
      )}
    </div>
  );
}
